import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DagrofaLonSetupRequest } from '@/models/payment';
import { usePaymentsMutations } from '@/services/paymentsMutations';
import { useHandleResponse } from '@/lib/hooks/useHandleResponse';
import { InputText } from '@/components/shared/InputText';
import { Box, GridLegacy as Grid } from '@mui/material';
import {
    PrimaryButtonStyle,
    SecondaryButtonStyle
} from '@/pages/company/common/IntegrationDialog';

interface DagrofaLonConnectProps {
    onClose?: () => void;
    onSaveSuccess: any;
}

export const DagrofaLonConnect = (props: DagrofaLonConnectProps) => {
    const { t } = useTranslation();
    const [dagrofaLonData, setDagrofaLonData] =
        useState<DagrofaLonSetupRequest>({
            instaPaidSalaryRecordCode: ''
        });
    const { dagrofaLonSetup } = usePaymentsMutations();

    const onClick = () => {
        dagrofaLonSetup.mutate(dagrofaLonData);
    };

    useHandleResponse({
        isSuccess: dagrofaLonSetup.isSuccess,
        error: dagrofaLonSetup.error,
        isPending: dagrofaLonSetup.isPending,
        successAlertMessage: t('connected'),
        isSuccessCallBack: () => {
            props.onSaveSuccess();
        }
    });

    return (
        <>
            <Box width={'100%'} margin={'20px 0 10px'}>
                <InputText
                    value={dagrofaLonData.instaPaidSalaryRecordCode}
                    label={t('instapaid_salary_record_code')}
                    onChange={(e) => {
                        setDagrofaLonData({
                            ...dagrofaLonData,
                            instaPaidSalaryRecordCode: e.target.value
                        });
                    }}
                    spacing="10px 0"
                />
            </Box>

            <Grid m={'20px 0'} container justifyContent={'space-around'}>
                <SecondaryButtonStyle
                    onClick={props.onClose}
                    sx={{ width: '170px' }}
                >
                    {t('back')}
                </SecondaryButtonStyle>

                <PrimaryButtonStyle
                    onClick={onClick}
                    sx={{ width: '170px' }}
                    disabled={!dagrofaLonData.instaPaidSalaryRecordCode}
                >
                    {t('connect')}
                </PrimaryButtonStyle>
            </Grid>
        </>
    );
};
